import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';
import { CoreContext } from './context/index.js';
import { w as withProviders } from './withProviders-l3mjYkR2.js';

const PageMaintenance = () => {
    const { t } = useTranslation('', { keyPrefix: '' });
    const { data: { siteConfig: { csrEmail }, }, } = useContext(CoreContext);
    return (React.createElement("div", { className: "container pg404", id: "page-404" },
        React.createElement("div", { className: "tagline-wrap" },
            React.createElement("h1", null, t('$common.$pages.$notice.heading')),
            React.createElement("section", null,
                React.createElement("section", null,
                    React.createElement("p", null, t('$common.$pages.$notice.paragraph', { csrEmail })))))));
};
var PageMaintinence = withProviders(PageMaintenance, { translation: true });

export { PageMaintinence as P };
//# sourceMappingURL=PageMaintenance-iWNOIvs_.js.map
